import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { appSettings } from 'app/appSettings';
import { ColdSubject } from 'app/core/guards/cold-subject';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { RootState } from 'app/core/store';
import { SessionState } from 'app/core/store/session/session.interface';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import { goAction } from '../store/router/router.actions';
import { debounceTime, filter, first, map } from 'rxjs/operators';
import { AuthenticatedGuard } from './authenticated.guard';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { ComesFromLaunchpadGuard } from 'app/core/guards/comes-from-launchpad.guard';

/**
 * Guard that customer is selected
 */
@Injectable({ providedIn: 'root' })
export class SelectedCustomerGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<RootState>;

  constructor(@Inject(forwardRef(() => Store)) store: Store<RootState>) {
    // constructor(private store: Store<RootState>) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    logger.debug('in SelectedCustomerGuard');
    return new ColdSubject(() => {
      // Is authenticated ?
      return this.store.select('session').pipe(
        // debounceTime(100),
        filter((session: SessionState) => !!(session.userContext.contextLoaded && session.selectedCustomer.loadSuccess)),
        first(),
        map((session: SessionState) => {
          // Is superUser ?
          const isSuperUser = session.userContext.isSuperUser;
          // Has active customer ?
          const hasSelectedCustomer = !!session.selectedCustomer.data;
          if (!hasSelectedCustomer && !isSuperUser) {
            this.store.dispatch(goAction({ path: appSettings.SELECT_CUSTOMER_ROUTE }));
            logger.debug('in SelectedCustomerGuard: false ####');
            return false;
          }
          logger.debug('in SelectedCustomerGuard: true');
          return true;
        })
      );
    });
  }

  getDependencies(): any {
    return [AuthenticatedGuard, ComesFromLaunchpadGuard];
  }

  getDependencyRouteData(): any {}
}
